module.exports = __webpack_public_path__ + "static/case-nike-ce5b8a8c7ce1a68a1ddf5bfcd4b0fca1.jpg";